/*
 * @Author: mkRui 1102163949@qq.com
 * @Date: 2025-10-10 18:20:25
 * @LastEditors: mkRui 1102163949@qq.com
 * @LastEditTime: 2025-10-12 16:18:56
 * @FilePath: /polordar-explorer/ui/home/indicators/utils/indicators.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';

import type { TChainIndicator } from '../types';

import config from 'configs/app';
import IconSvg from 'ui/shared/IconSvg';
import NativeTokenIcon from 'ui/shared/NativeTokenIcon';

const rollupFeature = config.features.rollup;
const isOptimisticRollup = rollupFeature.isEnabled && rollupFeature.type === 'optimistic';
const isArbitrumRollup = rollupFeature.isEnabled && rollupFeature.type === 'arbitrum';

export default function getIndicators(t: (key: string) => string): Array<TChainIndicator> {
  return [
    {
      id: 'daily_txs',
      title: t('home.indicators.dailyTxs.title'),
      titleMicroservice: (stats) => stats.daily_new_transactions?.info?.title,
      value: (stats) => stats.transactions_today === null ?
        t('common.na') :
        Number(stats.transactions_today).toLocaleString(undefined, { maximumFractionDigits: 2, notation: 'compact' }),
      valueMicroservice: (stats) => stats.yesterday_transactions?.value === null ?
        t('common.na') :
        Number(stats.yesterday_transactions?.value).toLocaleString(undefined, { maximumFractionDigits: 2, notation: 'compact' }),
      icon: <IconSvg name="transactions" boxSize={ 6 } bgColor="#56ACD1" borderRadius="base" color="white"/>,
      hint: t('home.indicators.dailyTxs.hint'),
      hintMicroservice: (stats) => stats.daily_new_transactions?.info?.description,
    },
    {
      id: 'daily_operational_txs',
      title: t('home.indicators.dailyOperationalTxs.title'),
      titleMicroservice: (stats) => {
        if (isArbitrumRollup) {
          return stats.daily_new_operational_transactions?.info?.title;
        } else if (isOptimisticRollup) {
          return stats.op_stack_daily_new_operational_transactions?.info?.title;
        }
        return '';
      },
      value: () => t('common.na'),
      valueMicroservice: (stats) => {
        if (isArbitrumRollup) {
          return stats.yesterday_operational_transactions?.value === null ?
            t('common.na') :
            Number(stats.yesterday_operational_transactions?.value).toLocaleString(undefined, { maximumFractionDigits: 2, notation: 'compact' });
        } else if (isOptimisticRollup) {
          return stats.op_stack_yesterday_operational_transactions?.value === null ?
            t('common.na') :
            Number(stats.op_stack_yesterday_operational_transactions?.value).toLocaleString(undefined, { maximumFractionDigits: 2, notation: 'compact' });
        }
        return;
      },
      icon: <IconSvg name="transactions" boxSize={ 6 } bgColor="#56ACD1" borderRadius="base" color="white"/>,
      hint: t('home.indicators.dailyOperationalTxs.hint'),
      hintMicroservice: (stats) => stats.daily_new_operational_transactions?.info?.description,
    },
    {
      id: 'coin_price',
      title: `${ config.chain.currency.symbol } ${ t('home.indicators.price') }`,
      value: (stats) => stats.coin_price === null ?
        '$' + t('common.na') :
        '$' + Number(stats.coin_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 }),
      valueDiff: (stats) => stats?.coin_price !== null ? stats?.coin_price_change_percentage : null,
      icon: <NativeTokenIcon boxSize={ 6 }/>,
      hint: `${ config.chain.currency.symbol } ${ t('home.indicators.tokenDailyPriceUsd') }`,
    },
    {
      id: 'secondary_coin_price',
      title: `${ config.chain.secondaryCoin.symbol } ${ t('home.indicators.price') }`,
      value: (stats) => !stats.secondary_coin_price || stats.secondary_coin_price === null ?
        '$' + t('common.na') :
        '$' + Number(stats.secondary_coin_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 }),
      valueDiff: () => null,
      icon: <NativeTokenIcon boxSize={ 6 } type="secondary"/>,
      hint: `${ config.chain.secondaryCoin.symbol } ${ t('home.indicators.tokenDailyPriceUsd') }`,
    },
    {
      id: 'market_cap',
      title: t('home.indicators.marketCap.title'),
      value: (stats) => stats.market_cap === null ?
        '$' + t('common.na') :
        '$' + Number(stats.market_cap).toLocaleString(undefined, { maximumFractionDigits: 2, notation: 'compact' }),
      icon: <IconSvg name="globe" boxSize={ 6 } bgColor="#6A5DCC" borderRadius="base" color="white"/>,
      // eslint-disable-next-line max-len
      hint: 'The total market value of a cryptocurrency\'s circulating supply. It is analogous to the free-float capitalization in the stock market. Market Cap = Current Price x Circulating Supply.',
    },
    {
      id: 'tvl',
      title: t('home.indicators.tvl.title'),
      value: (stats) => stats.tvl === null ?
        '$' + t('common.na') :
        '$' + Number(stats.tvl).toLocaleString(undefined, { maximumFractionDigits: 2, notation: 'compact' }),
      icon: <IconSvg name="lock" boxSize={ 6 } bgColor="#517FDB" borderRadius="base" color="white"/>,
      hint: 'Total value of digital assets locked or staked in a chain',
    },
  ];
}
